var _style, _desc, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyCareer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFCC00;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFCC33;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.6,59.9c-20.5,0-38-6.5-39.1-14.5c-0.8-5.8,7.2-9.8,19.3-11.6c0-0.2,0-0.4-0.1-0.6 c-16.1,2.4-27.4,8.5-27.6,16c-0.3,10.3,20.1,19.3,45.6,20.1c2.5,0.1,4.9,0.1,7.3,0c0-3.1,0-6.4,0-9.6 C62.2,59.8,60.4,59.9,58.6,59.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,23.5c-6.2,1.7-13.5,2.3-20.2,2.3s-14-0.7-20.2-2.3L17,28.3c4.4,1.2,9.5,2,14.3,2.3v30.9H36V47.3h4.8 v14.3h4.8V30.7c4.8-0.4,9.8-1.2,14.3-2.3L58.5,23.5z M38.4,23.5c2.6,0,4.8-2.2,4.8-4.8s-2.2-4.8-4.8-4.8s-4.8,2.2-4.8,4.8 S35.8,23.5,38.4,23.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "59.5,64.5 59.3,53.8 68.6,59 77.9,64.1 68.8,69.6 59.7,75.1  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCareer);
export default __webpack_public_path__ + "static/media/my-career.da3b64cb1ab6da882cd4841eb54f969e.svg";
export { ForwardRef as ReactComponent };